export const CEILING_DB = -1;
export const CEILING = 10 ** (CEILING_DB / 20);
export interface LimiterState { delay: number; left: Float32Array; right: Float32Array; peaks: Float64Array; indices: Float64Array; head: number; tail: number; frame: number; gain: number; release: number }
export function createLimiterState(sampleRate: number): LimiterState {
  'worklet';
  const delay = Math.max(1, Math.round(sampleRate * .005)), size = delay + 2;
  return { delay, left: new Float32Array(size), right: new Float32Array(size), peaks: new Float64Array(size), indices: new Float64Array(size), head: 0, tail: 0, frame: 0, gain: 1, release: Math.exp(-1 / (sampleRate * .05)) };
}
export function processLimiter(state: LimiterState, input: Float32Array[], output: Float32Array[], frames: number): void {
  'worklet';
  const ceiling = Math.pow(10, -1 / 20), n = state.left.length;
  for (let i = 0; i < frames; i++, state.frame++) {
    const l = input[0]?.[i] || 0, r = input[1]?.[i] ?? l;
    state.left[state.frame % n] = l; state.right[state.frame % n] = r;
    const peak = Math.max(Math.abs(l), Math.abs(r));
    while (state.head < state.tail && state.indices[state.head % n] < state.frame - state.delay) state.head++;
    while (state.head < state.tail && state.peaks[(state.tail - 1) % n] <= peak) state.tail--;
    state.peaks[state.tail % n] = peak; state.indices[state.tail++ % n] = state.frame;
    const max = state.peaks[state.head % n], target = max > ceiling ? ceiling / max : 1;
    state.gain = target < state.gain ? target : target + (state.gain - target) * state.release;
    const at = (state.frame - state.delay + n) % n;
    if (output[0]) output[0][i] = state.frame < state.delay ? 0 : Math.max(-ceiling, Math.min(ceiling, state.left[at] * state.gain));
    if (output[1]) output[1][i] = state.frame < state.delay ? 0 : Math.max(-ceiling, Math.min(ceiling, state.right[at] * state.gain));
  }
}
// Stereo-linked 5ms lookahead peak limiter, immediate attack, 50ms exponential release.
// Ceiling is in dBFS sample peaks. It is not a certified inter-sample true-peak limiter.
export class PeakLimiter {
  readonly latencyFrames: number;
  private state: LimiterState;
  constructor(sampleRate: number) {
    this.state = createLimiterState(sampleRate); this.latencyFrames = this.state.delay;
  }
  process(input: Float32Array[], output: Float32Array[], frames: number): void {
    processLimiter(this.state, input, output, frames);
  }
}
